
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.333 1.833v2.75M14.667 1.833v2.75","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M3.208 8.332h15.583","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}}),_c('path',{attrs:{"d":"M19.25 7.791v7.792c0 2.75-1.375 4.583-4.583 4.583H7.333c-3.208 0-4.583-1.833-4.583-4.583V7.791c0-2.75 1.375-4.583 4.583-4.583h7.333c3.209 0 4.584 1.833 4.584 4.583z","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M14.387 12.558h.005M14.387 15.308h.005M10.996 12.558h.005M10.996 15.308h.005M7.604 12.558h.005M7.603 15.308h.008","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    